import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { USER } from "../../../constants";
import eventType from "../../../prop-types/eventType";
import { Template } from "../../../commons/elements";
import orderItem from "../../../prop-types/orderItem";
import OrderHistoryList from "../components/order-history-list";
import "../styles/order-history.scss";
import {
  fetchUserPurchases,
  clearOrderHistory
} from "../../../state/user/actions";

const propTypes = {
  types: PropTypes.arrayOf(eventType).isRequired,
  // Map state to props
  userId: PropTypes.number.isRequired,
  purchases: PropTypes.arrayOf(orderItem),
  // Map dispatch to props
  fetchUserPurchasesAction: PropTypes.func.isRequired,
  clearOrderHistoryAction: PropTypes.func.isRequired
};

const defaultProps = {
  purchases: []
};

export function OrderHistoryContainer(props) {
  const {
    purchases,
    types,
    fetchUserPurchasesAction,
    userId,
    clearOrderHistoryAction
  } = props;
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchUserPurchasesAction(userId);
    return () => clearOrderHistoryAction();
  }, []);

  useEffect(() => {
    setIsLoading(!purchases);
  }, [purchases]);

  return (
    <Template
      types={types}
      header="Order History"
      tabName={USER}
      isLoading={isLoading}
    >
      <OrderHistoryList purchases={purchases} />
    </Template>
  );
}

OrderHistoryContainer.propTypes = propTypes;
OrderHistoryContainer.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  userId: state.user.user.id,
  purchases: state.user.purchases
});

const mapDispatchToProps = {
  fetchUserPurchasesAction: fetchUserPurchases,
  clearOrderHistoryAction: clearOrderHistory
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderHistoryContainer);
